import { Deserializable } from '../interfaces';

export class PublicCardData implements Deserializable {
  claveTelefono: string;
  colorLetra: string;
  colorTarjeta: string;
  colorFlecha?: string;
  fondoFlecha?: string;
  correo: string;
  empresa?: string;
  crearTarjeta: boolean;
  descripcion: string;
  domicilio: string;
  editarTarjeta: boolean;
  esHorizontal: boolean;
  habilitado: boolean;
  idTarjeta: number;
  idUsuario: number;
  iniciarSesion: boolean;
  nickName: string;
  nombre: string;
  profesion: string;
  telefono: string;
  popup: boolean = false;
  titulo: string;
  urlBanner: string;
  urlFotoPerfil: string;
  urlLogo: string;
  urlLogotipo: string;

  popUpHabilitado: number;
  tituloHabilitado: number;
  tituloPopUp: string; 
  preguntaHabilitado: number;
  pregunta: string;
  respuestas: any;
  imagenUrl: string;
  imagen: any;

  constructor() {
    this.claveTelefono = '';
    this.colorLetra = '';
    this.colorTarjeta = '';
    this.colorFlecha = '';
    this.fondoFlecha = '';
    this.correo = '';
    this.crearTarjeta = false;
    this.esHorizontal = false;
    this.descripcion = '';
    this.domicilio = '';
    this.editarTarjeta = false;
    this.habilitado = false;
    this.idTarjeta = 0;
    this.idUsuario = 0;
    this.iniciarSesion = false;
    this.nickName = '';
    this.nombre = '';
    this.profesion = '';
    this.telefono = '';
    this.titulo = '';
    this.urlBanner = '';
    this.urlFotoPerfil = '';
    this.empresa = '';
    this.urlLogo = '';
    this.urlLogotipo = '';
    this.popUpHabilitado = 0;
    this.tituloHabilitado = 0;
    this.tituloPopUp = '';
    this.preguntaHabilitado = 0;
    this.pregunta = '';
    this.respuestas = [];
    this.imagenUrl = '';
    this.imagen = {} as File;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
